/**
 * Punto di ingresso della SPA.
 *
 * I font sono importati come pacchetti e finiscono nel bundle: nessuna
 * richiesta a un CDN terzo. Sul portale pubblico questo e' un obbligo (C.SI.3.1
 * vieta cookie e asset di terze parti prima del consenso); qui non lo sarebbe,
 * ma tenere lo stesso comportamento evita che l'abitudine sbagliata migri da un
 * progetto all'altro — e il back-office funziona anche su una rete chiusa.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Geist e Geist Mono, i caratteri del back-office gemello, in versione
// variabile: un file per famiglia copre tutti i pesi.
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";

import "./styles/tema.css";
import "./styles/base.css";

import { App } from "./App";

const radice = document.getElementById("root");
if (!radice) throw new Error("Elemento #root non presente nel documento.");

createRoot(radice).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
